import { Collapse } from "reactstrap";

const CollapseContainer = ({ isOpen, children }) => {
  return (
    <div>
      <Collapse isOpen={isOpen}>{children}</Collapse>
    </div>
  );
};

export default CollapseContainer;
